<template>

    <div class="collapse directory__filter-dropdown-menu" id="directory__filter-dropdown-menu">
      <div class="directory__filter-dropdown-content text-left">
        <div class="directory-filter-dropdown-title-container">
          <h3 class="directory-filter-dropdown-title">Filters</h3>
        </div>
        <div class="col-12 form-group" :class="filterKey" v-if="event.is_base_style" v-for="(filter, filterKey) in attendeeFieldFiltersOnly" :key="filterKey">
            <button class="btn filter__inner-dropdown " type="button" data-toggle="collapse" :data-target="`#collapse-${ filterKey }`" aria-expanded="false" :aria-controls="`collapse-${filterKey}`" :data-key="filterKey" :arial-label="dirFilterMixin_stripTags(filter['label'])" :title="dirFilterMixin_stripTags(filter['label'])">{{filter.label}}<i class="pull-right fal fa-angle-right caret-open"></i></button>
            <div class="collapse default-filter-collapse" :class="`collapse-${filterKey }`" :id="`collapse-${filterKey }`">
                <div class="filter-values">
                    <div class="filter" v-for="(value, valueIndex) in filter.values" :key="valueIndex">
                      <span class="filter__label">{{dirFilterMixin_filterKeyLabelMap[value] || dirFilterMixin_formatLabel(value)}}</span>
                        <label class="">
                            <input class="filter-checkbox" 
                              type="checkbox" 
                              :name="filterKey" 
                              :value="filter.value"
                              :checked="userSelection && userSelection[filterKey] && userSelection[filterKey].includes(value)"
                              @change="dirFilterMixin_handleUserCheck($event, filterKey, value)"
                              >
                            <i></i>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="event && event.attendee_global_presence && !event.legacy_template" class="col-12 form-group online_status">
            <div id="online_status">
                <div class="filter border-0">
                    <span class="filter__label base-filter-category" title="Online status filter" aria-label="Online status filter">
                      {{dirFilterMixin_onlineNowLabel}}
                    </span>
                    <label class="">
                        <input 
                          class="filter-checkbox" 
                          type="checkbox" 
                          name="online_status" 
                          value="online" 
                          @change="dirFilterMixin_handleUserCheck($event,'online_status', 'online')"
                          title="Online status filter" 
                          aria-label="Online status filter"
                          :checked="userSelection && userSelection['online_status'] && userSelection['online_status'].includes('online')"
                          />
                        <i></i>
                    </label>
                </div>
            </div>
        </div>
        <div v-if="dir.enable_enrollable_filter" class="col-12 form-group">
            <div id="enrollable_availability">
                <div class="filter border-0">
                    <span class="filter__label base-filter-category">{{ dir.enrollable_capacity_button_text }}</span>
                    <label class="">
                        <input 
                          class="filter-checkbox" 
                          type="checkbox" 
                          :name="dir.enrollable_capacity_button_text" 
                          value="enrollable_availability"
                          :checked="userSelection && userSelection['Show Available'] && userSelection['Show Available'].includes('enrollable_availability')"
                          @change="dirFilterMixin_handleUserCheck($event, 'Show Available', 'enrollable_availability')"
                          
                          >
                        <i></i>
                    </label>
                </div>
            </div>
        </div>

        <div class="col-12 form-group" :class="filterKey" v-if="event.is_base_style == false" v-for="(filter, filterKey) in attendeeFieldFiltersOnly" :key="filterKey">
            <button class="btn filter__inner-dropdown " type="button" data-toggle="collapse" :data-target="`#collapse-${ filterKey }`" aria-expanded="false" :aria-controls="`collapse-${filterKey}`" :data-key="filterKey" :arial-label="dirFilterMixin_stripTags(filter['label'])" :title="dirFilterMixin_stripTags(filter['label'])">{{filter.label}}<i class="pull-right fal fa-angle-right caret-open"></i></button>
            <div class="collapse default-filter-collapse" :class="`collapse-${filterKey }`" :id="`collapse-${filterKey }`">
                <div class="filter-values">
                    <div class="filter" v-for="(value, valueIndex) in filter.values" :key="valueIndex">
                      <span class="filter__label">{{dirFilterMixin_filterKeyLabelMap[value] || dirFilterMixin_formatLabel(value)}}</span>
                        <label class="">
                            <input class="filter-checkbox" 
                              type="checkbox" 
                              :name="filterKey" 
                              :value="filter.value"
                              :checked="userSelection && userSelection[filterKey] && userSelection[filterKey].includes(value)"
                              @change="dirFilterMixin_handleUserCheck($event, filterKey, value)"
                              >
                            <i></i>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 directory__filter-clear btn-clear-filters uppercase text-left" @click="dirFilterMixin_clearClicked" title="Clear filters link" aria-label="Clear filters link">
            {{dirFilterMixin_clearAllLabel}}
            <i class="directory__filter-clear-icon fas fa-times"></i>&nbsp;<span>
        </span>
        </div>
      </div>
    </div>

</template>

<script>
// import { BDropdown, BFormCheckbox, BFormCheckboxGroup, BDropdownForm, BFormGroup, BBadge } from "bootstrap-vue"
import DirectoryFilterMixin from "./DirectoryFilterMixin"

  export default {
    components: {
    },
    props: {
      filterData: {
        type: Object,
        default: ()=>{
          return {"attendee_type":{"key":"attendee_type","label":"Attendee Type","order":1,"values":["general"],"value_labels":[],"filter_type":"select"},"select_item":{"key":"select_item","label":"My Select Menu","order":2,"values":["value1","value2","value3"],"value_labels":{"value1":"Label 1","value2":"Label 2","value3":"Label 3"},"filter_type":"select"},"job_title":{"key":"job_title","label":"Job Title","order":3,"values":[],"value_labels":[],"filter_type":"select"}}
        }
      },
      userSelection: {
        type: Object,
        default: ()=>{return {}}
      },
      event: {
        type: Object,
        required: true,
      },
      dir: {
        type: Object,
        required: true,

      }
    },
    data() {
      return {
        tags: [],
      }
    },
    mounted(){
      $('.default-filter-collapse').on('show.bs.collapse', function (event) {
        const id = event.target.id;
        const $icon = $(`button[data-target="#${id}"] i`);
        $icon.removeClass('fa-angle-right');
        $icon.addClass('fa-angle-down');
      })
      $('.default-filter-collapse').on('hide.bs.collapse', function (event) {
        const id = event.target.id;
        const $icon = $(`button[data-target="#${id}"] i`);
        $icon.removeClass('fa-angle-down');
        $icon.addClass('fa-angle-right');
      })
    },
    beforeDestroy(){
      $('.default-filter-collapse').off('show.bs.collapse');
      $('.default-filter-collapse').off('hide.bs.collapse');
    },
    mixins: [
      DirectoryFilterMixin
    ],
    computed: {
      attendeeFieldFiltersOnly: function(){
        const finalFilters = {}
        for (const [key, value] of Object.entries(this.filterData)) {
          if (value.filter_type !== 'non_categorized_checkbox') {
            finalFilters[key] = value
          }
        }
        return finalFilters
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

i.filter-tag-icon.fa.fa-times {
    font-size: 75%;
}

.directory-tag.list-complete-item {
  transition: all .5s;
  display: inline-block;
}
.directory-filter-item.list-complete-item {
  transition: all .5s;
  display: flex;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
}
.list-complete-leave-active {
  position: absolute;
}


.directory-filter-tags-container {
  font-size: 18px;
}

.pill {
  border-radius: 10rem;
}

</style>

<style>

.directory-filter-item {
    display: flex;
}
.directory-filter-item-wrapper {
    display: flex;
}
.directory-filter-dropdown-btn.dropdown-toggle {
    display: flex;
    align-items: center;
}
.directory-filter-tags-container {
    display: flex;
}
.directory-filter-component {
  display: flex;
  align-items: center;
}
.directory-filter-clear-btn {
  background: none;
  border: none;
}
.directory-filter-clear-btn i.clear-filters-icon, .directory-filter-clear-btn {
  color: var(--theme-text-color)
}
</style>